// src/theme.js

import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    // --- THIS IS THE KEY CHANGE ---
    mode: 'dark', 
    primary: {
      main: '#E95420', // Keep the vibrant Ubuntu Orange
    },
    background: {
      default: '#0d1b2a', // A deep, dark navy blue for the main background
      paper: '#1c2e4a',   // A slightly lighter blue for surfaces like the sidebar and chat bubbles
    },
    text: {
        primary: '#f1f1f1', // A soft white for primary text
        secondary: '#b0bec5', // A light grey for secondary text
    }
  },
  typography: {
    fontFamily: "'Ubuntu', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 700,
        },
      },
    },
  },
});